<template>
 <div id="page-wrap" v-if="loggedIn">
   <PageHeader></PageHeader>
   <div class="container content-wrap">
     <div class="row">
     <ProfileContent :nav="'refunds'"></ProfileContent>
      <Refunds></Refunds>
     </div>
   </div>
 </div>
</template>

<script>
import PageHeader from './PageHeader/index'
import Refunds from './Refunds/index'
import ProfileContent from './ProfileContent/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Paymenthistory',
  data () {
    return {

    }
  },
  computed:{
    ...mapGetters([
      "paymentTypes",
      "loggedIn"
    ])
  },
  components: { PageHeader, Refunds, ProfileContent },
  mounted () {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Refunds.vue